module.exports = __webpack_public_path__ + "img/orange-rectangle-table-4.24ddbf6f.png";